var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7639",
    "data-name": "Group 7639",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_549",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#6dc1c7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7127",
    transform: "translate(9.208 10.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    d: "M5.4,27.594a.9.9,0,0,1-.9-.9V20.4a.9.9,0,1,1,1.8,0v6.3A.9.9,0,0,1,5.4,27.594Z",
    transform: "translate(-1.802 -9.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    d: "M5.4,11.094a.9.9,0,0,1-.9-.9V3.9a.9.9,0,0,1,1.8,0v6.3A.9.9,0,0,1,5.4,11.094Z",
    transform: "translate(-1.802 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    d: "M17.4,26.393a.9.9,0,0,1-.9-.9V17.4a.9.9,0,1,1,1.8,0v8.094A.9.9,0,0,1,17.4,26.393Z",
    transform: "translate(-6.607 -8.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5327",
    d: "M17.4,9.3a.9.9,0,0,1-.9-.9V3.9a.9.9,0,1,1,1.8,0V8.4A.9.9,0,0,1,17.4,9.3Z",
    transform: "translate(-6.607 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    d: "M29.4,28.8a.9.9,0,0,1-.9-.9V23.4a.9.9,0,0,1,1.8,0v4.5A.9.9,0,0,1,29.4,28.8Z",
    transform: "translate(-11.412 -10.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    d: "M29.4,12.893a.9.9,0,0,1-.9-.9V3.9a.9.9,0,1,1,1.8,0v8.094A.9.9,0,0,1,29.4,12.893Z",
    transform: "translate(-11.412 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5330",
    d: "M6.3,21.3H.9a.9.9,0,0,1,0-1.8H6.3a.9.9,0,0,1,0,1.8Z",
    transform: "translate(0 -9.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5331",
    d: "M18.3,12.3H12.9a.9.9,0,0,1,0-1.8h5.4a.9.9,0,1,1,0,1.8Z",
    transform: "translate(-4.805 -6.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5332",
    d: "M30.3,24.3H24.9a.9.9,0,0,1,0-1.8h5.4a.9.9,0,1,1,0,1.8Z",
    transform: "translate(-9.61 -10.809)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.22e2eb2caff438ac5437c12b543dd67a.svg";
export { ForwardRef as ReactComponent };